/*
 app dependencies
 - var body

 lib dependencies
*/

const scSidebarStatementFilters = (function($)
{
    //public
    const   sidebarId = 'statement-filters',
            overviewWrapSelector = '.js-statements-overview';
    //private
    const   _triggers = document.querySelectorAll(`.js-show-sidebar[data-sidebar-id="${sidebarId}"]`),
            _bodyToggleClass = `show-sidebar-${sidebarId}`,
            //_overviewWrapSelector = '.js-statements-overview',
            _filterButtonWrap = document.querySelector('.js-filter-btn-wrap'),
            _summaryWrap = document.querySelector('.js-filter-statement-summary'),
            _textFields = ["Title"],
            _radioFields = ["Person","Organisation","Category","Status"];
    let     _sidebarDiv,
            _form;

	//module functions
	function init()
	{
		for (const trigger of _triggers)
        {
            trigger.addEventListener('click', function(e)
            {
                e.preventDefault();
                _show();
            });
        }
	}

    function _show()
    {
        scSidebar.show(_bodyToggleClass);
    }

    function contentLoaded(sidebarDiv)
    {
        scSidebarFilters.contentLoaded(sidebarDiv, this);

        _form = sidebarDiv.querySelector('form');


        //save form values
        //_initialFormValues = getFormValues();

        /*
        //references to elements
        _sidebarDiv = sidebarDiv;
        _form = _sidebarDiv.querySelector('form');

        //init
        scOptionSearch.init(sidebarDiv);

        _form.addEventListener('submit', function(e)
        {
            e.preventDefault();

            const newUrl = _getSearchUrl();

            //hide sidebar
            scSidebar.hide();

            //show overview loader
            document.querySelector(_overviewWrapSelector).classList.add('loading-container--loading');

            //ajax call
            doAjax({
                ajaxUrl: newUrl,
                onSuccess: _onUpdateSuccess,
                onError: _onUpdateError,
                params: {
                    newUrl
                }
            })
        });
        */
    }

        /*function _getSearchUrl()
        {
            const params = $(_form).find("input").filter(function()
            {
                return this.value.trim().length > 0
            }).serialize();

            return `${_form.getAttribute('action')}?${params}`;
        }

        function _onUpdateSuccess(response, params)
        {
            document.querySelector(_overviewWrapSelector).classList.remove('loading-container--loading');

            try
            {
                //parse html from response
                const parser = new DOMParser();
                const loadedDoc = parser.parseFromString(response, "text/html");
                const newOverviewWrap = loadedDoc.querySelector(_overviewWrapSelector);
                if (newOverviewWrap)
                {
                    const newHtml = newOverviewWrap.outerHTML;
                    //set new html
                    document.querySelector(_overviewWrapSelector).outerHTML = newHtml;
                    //update url
                    history.pushState({}, document.title, params.newUrl);
                    //update summary
                    const summary = _constructSummary();
                    if (summary)
                    {
                        _filterButtonWrap.classList.add('filter-btn-wrap--with-summary');
                        _summaryWrap.innerHTML = summary;
                    }
                    else
                    {
                        _filterButtonWrap.classList.remove('filter-btn-wrap--with-summary');
                        _summaryWrap.innerHTML = '';
                    }
                }
                else
                {
                    throw 'Er is iets misgegaan bij het ophalen van de resultaten';
                }
            }
            catch (err)
            {
                lmnDialog.alert(`<p>${err}</p>`);
            }
        }*/

            function _constructSummary()
            {
                let summary = '';
                const defaultVal = 'Geen voorkeur';

                //Gecontroleerde stellingen met zoekterm haring door Jesse Klaver van GroenLinks over immigratie tijdens Partijcongres GroenLinks

                //status
                const statusValue = document.querySelector('.js-filter-statements-label-status').textContent.trim();
                if (statusValue != defaultVal)
                {
                    summary += statusValue;
                }
                else
                {
                    summary += 'Alle stellingen';
                }

                //search
                const searchValue = document.querySelector('.js-filter-statements-search-input').value;
                if (searchValue != '')
                {
                    summary += ` met zoekterm <span class="filter-btn-wrap__highlight">'${searchValue}'</span>`;
                }

                //person
                const personValue = document.querySelector('.js-filter-statements-label-person').textContent.trim();
                if (personValue != defaultVal)
                {
                    summary += ` door <span class="filter-btn-wrap__highlight">${personValue}</span>`;
                }

                //organisation
                const organisationValue = document.querySelector('.js-filter-statements-label-organisation').textContent.trim();
                if (organisationValue != defaultVal)
                {
                    summary += ` van <span class="filter-btn-wrap__highlight">${organisationValue}</span>`;
                }

                //category
                const categoryValue = document.querySelector('.js-filter-statements-label-category').textContent.trim();
                if (categoryValue != defaultVal && categoryValue != 'Alle onderwerpen')
                {
                    summary += ` over <span class="filter-btn-wrap__highlight">${categoryValue}</span>`;
                }

                //event
                const eventValue = document.querySelector('.js-filter-statements-label-event').textContent.trim();
                if (eventValue != defaultVal)
                {
                    summary += ` tijdens <span class="filter-btn-wrap__highlight">${eventValue}</span>`;
                }

                return (summary == 'Alle stellingen') ? false : summary;
            }

        /*function restoreInitialFormValues()
        {
            setFormValues(_initialFormValues);
        }*/

        /*function _onUpdateError(jqxhr, textStatus, errorThrown, params)
        {
            document.querySelector(_overviewWrapSelector).classList.remove('loading-container--loading');
            //error?
            if (!userAbortedAjax(jqxhr)) alert(errorThrown);
        }*/

        function updateSummary()
        {
            const summary = _constructSummary();
            if (summary)
            {
                _filterButtonWrap.classList.add('filter-btn-wrap--with-summary');
                _summaryWrap.innerHTML = summary;
            }
            else
            {
                _filterButtonWrap.classList.remove('filter-btn-wrap--with-summary');
                _summaryWrap.innerHTML = '';
            }
        }



        function getFormValues()
        {
            const formValues = {};

            _textFields.forEach(function(fieldName)
            {
                formValues[fieldName] = _form.querySelector(`input[name="${fieldName}"]`).value;
            });
            _radioFields.forEach(function(fieldName)
            {
                const checkedField = _form.querySelector(`input[name="${fieldName}"]:checked`);
                formValues[fieldName] = checkedField ? checkedField.value : "";
            });

            return formValues;
        }

        function setFormValues(formValues)
        {
            const changeEvent = document.createEvent('HTMLEvents');
            changeEvent.initEvent('change', true, true);

            _textFields.forEach(function(fieldName)
            {
                const val = formValues[fieldName] || "";
                _form.querySelector(`input[name="${fieldName}"]`).value = val;
            });
            _radioFields.forEach(function(fieldName)
            {
                const val = formValues[fieldName] || "";
                const fieldToCheck = _form.querySelector(`input[name="${fieldName}"][value="${val}"]`);
                if (fieldToCheck)
                {
                    fieldToCheck.checked = true;
                    fieldToCheck.dispatchEvent(changeEvent);
                }
            });
        }


	//reveal public vars and functions
	return {
		//vars
        sidebarId,
        overviewWrapSelector,
		//functions
		init,
        contentLoaded,
        getFormValues,
        setFormValues,
        //restoreInitialFormValues,
        updateSummary
	};

})(jQuery);
